import { vModelCheckbox as _vModelCheckbox, createVNode as _createVNode, withDirectives as _withDirectives, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, renderList as _renderList, Fragment as _Fragment, resolveComponent as _resolveComponent, withModifiers as _withModifiers, createTextVNode as _createTextVNode, withCtx as _withCtx, vModelText as _vModelText } from "vue"

const _hoisted_1 = {
  class: "table-responsive mb-3 font-12",
  style: {"min-height":"350px"}
}
const _hoisted_2 = { class: "table table-bordered table-shadowed mb-0" }
const _hoisted_3 = { class: "table-primary nowrap-text" }
const _hoisted_4 = {
  key: 0,
  scope: "col"
}
const _hoisted_5 = /*#__PURE__*/_createVNode("p", null, "All", -1)
const _hoisted_6 = { scope: "col" }
const _hoisted_7 = { scope: "col" }
const _hoisted_8 = { scope: "col" }
const _hoisted_9 = { scope: "col" }
const _hoisted_10 = { scope: "col" }
const _hoisted_11 = { scope: "col" }
const _hoisted_12 = { scope: "col" }
const _hoisted_13 = {
  key: 1,
  scope: "col"
}
const _hoisted_14 = { key: 0 }
const _hoisted_15 = { key: 0 }
const _hoisted_16 = { key: 1 }
const _hoisted_17 = { key: 2 }
const _hoisted_18 = { key: 0 }
const _hoisted_19 = { key: 1 }
const _hoisted_20 = { key: 3 }
const _hoisted_21 = { key: 4 }
const _hoisted_22 = { key: 5 }
const _hoisted_23 = { class: "file-actions position-relative" }
const _hoisted_24 = { class: "dropdown" }
const _hoisted_25 = /*#__PURE__*/_createVNode("a", {
  class: "dropdown-toggle",
  type: "button",
  id: "dropdownMenuButton",
  "data-toggle": "dropdown",
  "aria-haspopup": "true",
  "aria-expanded": "true"
}, [
  /*#__PURE__*/_createVNode("i", { class: "fa fa-ellipsis-v" })
], -1)
const _hoisted_26 = {
  class: "dropdown-menu dropdown-menu-right",
  "aria-labelledby": "dropdownMenuButton"
}
const _hoisted_27 = /*#__PURE__*/_createVNode("i", { class: "fa fa-eye mr-2" }, null, -1)
const _hoisted_28 = /*#__PURE__*/_createVNode("i", { class: "fa fa-plus mr-2" }, null, -1)
const _hoisted_29 = /*#__PURE__*/_createVNode("i", { class: "fa fa-eye mr-2" }, null, -1)
const _hoisted_30 = /*#__PURE__*/_createVNode("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  width: "16",
  height: "16",
  fill: "currentColor",
  class: "bi bi-ui-checks mr-2",
  viewBox: "0 0 16 16"
}, [
  /*#__PURE__*/_createVNode("path", { d: "M7 2.5a.5.5 0 0 1 .5-.5h7a.5.5 0 0 1 .5.5v1a.5.5 0 0 1-.5.5h-7a.5.5 0 0 1-.5-.5zM2 1a2 2 0 0 0-2 2v2a2 2 0 0 0 2 2h2a2 2 0 0 0 2-2V3a2 2 0 0 0-2-2zm0 8a2 2 0 0 0-2 2v2a2 2 0 0 0 2 2h2a2 2 0 0 0 2-2v-2a2 2 0 0 0-2-2zm.854-3.646a.5.5 0 0 1-.708 0l-1-1a.5.5 0 1 1 .708-.708l.646.647 1.646-1.647a.5.5 0 1 1 .708.708zm0 8a.5.5 0 0 1-.708 0l-1-1a.5.5 0 0 1 .708-.708l.646.647 1.646-1.647a.5.5 0 0 1 .708.708zM7 10.5a.5.5 0 0 1 .5-.5h7a.5.5 0 0 1 .5.5v1a.5.5 0 0 1-.5.5h-7a.5.5 0 0 1-.5-.5zm0-5a.5.5 0 0 1 .5-.5h5a.5.5 0 0 1 0 1h-5a.5.5 0 0 1-.5-.5m0 8a.5.5 0 0 1 .5-.5h5a.5.5 0 0 1 0 1h-5a.5.5 0 0 1-.5-.5" })
], -1)
const _hoisted_31 = /*#__PURE__*/_createVNode("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  width: "16",
  height: "16",
  fill: "currentColor",
  class: "bi bi-card-list mr-2",
  viewBox: "0 0 16 16"
}, [
  /*#__PURE__*/_createVNode("path", { d: "M14.5 3a.5.5 0 0 1 .5.5v9a.5.5 0 0 1-.5.5h-13a.5.5 0 0 1-.5-.5v-9a.5.5 0 0 1 .5-.5zm-13-1A1.5 1.5 0 0 0 0 3.5v9A1.5 1.5 0 0 0 1.5 14h13a1.5 1.5 0 0 0 1.5-1.5v-9A1.5 1.5 0 0 0 14.5 2z" }),
  /*#__PURE__*/_createVNode("path", { d: "M5 8a.5.5 0 0 1 .5-.5h7a.5.5 0 0 1 0 1h-7A.5.5 0 0 1 5 8m0-2.5a.5.5 0 0 1 .5-.5h7a.5.5 0 0 1 0 1h-7a.5.5 0 0 1-.5-.5m0 5a.5.5 0 0 1 .5-.5h7a.5.5 0 0 1 0 1h-7a.5.5 0 0 1-.5-.5m-1-5a.5.5 0 1 1-1 0 .5.5 0 0 1 1 0M4 8a.5.5 0 1 1-1 0 .5.5 0 0 1 1 0m0 2.5a.5.5 0 1 1-1 0 .5.5 0 0 1 1 0" })
], -1)
const _hoisted_32 = /*#__PURE__*/_createVNode("i", { class: "fa fa-edit mr-2" }, null, -1)
const _hoisted_33 = { key: 0 }
const _hoisted_34 = { key: 1 }
const _hoisted_35 = { class: "modal-wrap default-modal" }
const _hoisted_36 = {
  class: "modal fade",
  "data-backdrop": "static",
  "data-keyboard": "false",
  id: "taskCompleteModal",
  tabindex: -1,
  "aria-labelledby": "exampleModalLabel",
  "aria-hidden": "true"
}
const _hoisted_37 = { class: "modal-dialog modal-dialog-centered" }
const _hoisted_38 = { class: "modal-content" }
const _hoisted_39 = { class: "modal-header" }
const _hoisted_40 = { class: "d-block" }
const _hoisted_41 = {
  class: "modal-title",
  id: "exampleModalLabel"
}
const _hoisted_42 = { class: "text-muted" }
const _hoisted_43 = /*#__PURE__*/_createVNode("span", { "aria-hidden": "true" }, "×", -1)
const _hoisted_44 = { class: "modal-body" }
const _hoisted_45 = { class: "form-wrap pt-0" }
const _hoisted_46 = { class: "form-group" }
const _hoisted_47 = { for: "exampleInputEmail1" }
const _hoisted_48 = { class: "form-group" }
const _hoisted_49 = { for: "exampleInputEmail1" }
const _hoisted_50 = { class: "modal-footer" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_ToDoMembersListForTaskTable = _resolveComponent("ToDoMembersListForTaskTable")
  const _component_ToDoPhaseStatus = _resolveComponent("ToDoPhaseStatus")
  const _component_ToDoListAddPhaseModal = _resolveComponent("ToDoListAddPhaseModal")
  const _component_SuccessfulModalCustom = _resolveComponent("SuccessfulModalCustom")
  const _component_router_link = _resolveComponent("router-link")
  const _component_ErrorList = _resolveComponent("ErrorList")
  const _component_DragAndDropZone = _resolveComponent("DragAndDropZone")
  const _component_AppImageList = _resolveComponent("AppImageList")
  const _component_ToDoTaskLogModal = _resolveComponent("ToDoTaskLogModal")

  return (_openBlock(), _createBlock(_Fragment, null, [
    _createVNode("div", _hoisted_1, [
      _createVNode("table", _hoisted_2, [
        _createVNode("thead", _hoisted_3, [
          _createVNode("tr", null, [
            (_ctx.showAction)
              ? (_openBlock(), _createBlock("th", _hoisted_4, [
                  _withDirectives(_createVNode("input", {
                    type: "checkbox",
                    disabled: _ctx.hasDoneStatus,
                    "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => (_ctx.state.data.selectAll = $event))
                  }, null, 8, ["disabled"]), [
                    [_vModelCheckbox, _ctx.state.data.selectAll]
                  ]),
                  _hoisted_5
                ]))
              : _createCommentVNode("", true),
            _createVNode("th", _hoisted_6, _toDisplayString(_ctx.$t('title_of_task')), 1),
            _createVNode("th", _hoisted_7, _toDisplayString(_ctx.$t('description')), 1),
            _createVNode("th", _hoisted_8, _toDisplayString(_ctx.$t('assignees')), 1),
            _createVNode("th", _hoisted_9, _toDisplayString(_ctx.$t('start_date')), 1),
            _createVNode("th", _hoisted_10, _toDisplayString(_ctx.$t('end_date')), 1),
            _createVNode("th", _hoisted_11, _toDisplayString(_ctx.$t('status')), 1),
            _createVNode("th", _hoisted_12, _toDisplayString(_ctx.$t('invoice_status')), 1),
            (_ctx.showAction)
              ? (_openBlock(), _createBlock("th", _hoisted_13, _toDisplayString(_ctx.$t('action')), 1))
              : _createCommentVNode("", true)
          ])
        ]),
        (_ctx.state.data.taskList && _ctx.state.data.taskList.length)
          ? (_openBlock(), _createBlock("tbody", _hoisted_14, [
              (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.state.data.taskList, (childPhase, childPhaseIndex) => {
                return (_openBlock(), _createBlock("tr", { key: childPhaseIndex }, [
                  (_ctx.showAction && (childPhase.status_detail && childPhase.status_detail.status))
                    ? (_openBlock(), _createBlock("td", _hoisted_15, [
                        _withDirectives(_createVNode("input", {
                          type: "checkbox",
                          disabled: 
                childPhase.status_detail.status.code !== 'done' || childPhase.invoice && childPhase.invoice.uuid
              ,
                          "onUpdate:modelValue": ($event: any) => (childPhase.isChecked = $event),
                          onChange: ($event: any) => (_ctx.check(childPhase))
                        }, null, 40, ["disabled", "onUpdate:modelValue", "onChange"]), [
                          [_vModelCheckbox, childPhase.isChecked]
                        ])
                      ]))
                    : _createCommentVNode("", true),
                  _createVNode("td", null, [
                    _createVNode("p", null, _toDisplayString(childPhase.name ? childPhase.name : _ctx.$t('n_a')), 1)
                  ]),
                  _createVNode("td", null, [
                    _createVNode("p", null, _toDisplayString(childPhase.description ? childPhase.description : _ctx.$t('n_a')), 1)
                  ]),
                  (childPhase.allMembers && childPhase.allMembers.length)
                    ? (_openBlock(), _createBlock("td", _hoisted_16, [
                        (childPhase.allMembers && childPhase.allMembers.length)
                          ? (_openBlock(), _createBlock(_component_ToDoMembersListForTaskTable, {
                              key: 0,
                              projectMembers: childPhase.allMembers,
                              activePhase: childPhase
                            }, null, 8, ["projectMembers", "activePhase"]))
                          : _createCommentVNode("", true)
                      ]))
                    : (_openBlock(), _createBlock("td", _hoisted_17, _toDisplayString(_ctx.$t('n_a')), 1)),
                  _createVNode("td", null, [
                    _createVNode("p", null, _toDisplayString(childPhase.localStartedDate
                  ? childPhase.localStartedDate
                  : _ctx.$t('n_a')), 1)
                  ]),
                  _createVNode("td", null, [
                    _createVNode("p", null, _toDisplayString(childPhase.localEndDate ? childPhase.localEndDate : _ctx.$t('n_a')), 1)
                  ]),
                  _createVNode("td", null, [
                    (childPhase.status)
                      ? (_openBlock(), _createBlock("p", _hoisted_18, [
                          _createVNode(_component_ToDoPhaseStatus, {
                            phase: childPhase.status_detail
                          }, null, 8, ["phase"])
                        ]))
                      : (_openBlock(), _createBlock("p", _hoisted_19, _toDisplayString(_ctx.$t('n_a')), 1))
                  ]),
                  (childPhase.invoice && childPhase.invoice.uuid)
                    ? (_openBlock(), _createBlock("td", _hoisted_20, [
                        _createVNode("strong", null, _toDisplayString(_ctx.$t('generated')), 1),
                        (_ctx.role === 5)
                          ? (_openBlock(), _createBlock("button", {
                              key: 0,
                              onClick: _withModifiers(($event: any) => (_ctx.downloadFile(childPhase.invoice.pdf_url)), ["prevent"]),
                              class: "invoice-btn to-upper"
                            }, _toDisplayString(_ctx.$t('view')), 9, ["onClick"]))
                          : _createCommentVNode("", true)
                      ]))
                    : (_openBlock(), _createBlock("td", _hoisted_21, _toDisplayString(_ctx.$t('n_a')), 1)),
                  (_ctx.showAction)
                    ? (_openBlock(), _createBlock("td", _hoisted_22, [
                        _createVNode("div", _hoisted_23, [
                          _createVNode("div", _hoisted_24, [
                            _hoisted_25,
                            _createVNode("div", _hoisted_26, [
                              (_ctx.isActive(childPhase.permissions, 'view_phase_detail') || _ctx.hasRole(['estimation_member']))
                                ? (_openBlock(), _createBlock("a", {
                                    key: 0,
                                    class: "dropdown-item",
                                    href: "javascript:void(0)",
                                    onClick: ($event: any) => (_ctx.taskViewDetail(childPhase))
                                  }, [
                                    _hoisted_27,
                                    _createTextVNode(_toDisplayString(_ctx.$t('view_details')), 1)
                                  ], 8, ["onClick"]))
                                : _createCommentVNode("", true),
                              (
                      _ctx.isActive(childPhase.permissions, 'add_member_to_task') && !(_ctx.projectStatus ==2))
                                ? (_openBlock(), _createBlock("a", {
                                    key: 1,
                                    class: "dropdown-item",
                                    href: "javascript:void(0)",
                                    onClick: ($event: any) => (_ctx.redirectToAddMemerToPhase(childPhase))
                                  }, [
                                    _hoisted_28,
                                    _createTextVNode(" " + _toDisplayString(_ctx.$t('add_members')), 1)
                                  ], 8, ["onClick"]))
                                : _createCommentVNode("", true),
                              (
                      (_ctx.isActive(childPhase.permissions, 'view_task_log')) &&
                      childPhase.localStartedDate &&
                      childPhase.localEndDate
                    )
                                ? (_openBlock(), _createBlock("a", {
                                    key: 2,
                                    class: "dropdown-item",
                                    href: "javascript:void(0)",
                                    onClick: ($event: any) => (_ctx.redirectToPhaseLogs(childPhase))
                                  }, [
                                    _hoisted_29,
                                    _createTextVNode(_toDisplayString(_ctx.$t('view_log')), 1)
                                  ], 8, ["onClick"]))
                                : _createCommentVNode("", true),
                              ((_ctx.isActive(childPhase.permissions, 'log_entry')) && childPhase.log_type !== 5 &&  childPhase.localStartedDate &&
                      childPhase.localEndDate && !(_ctx.projectStatus ==2))
                                ? (_openBlock(), _createBlock("a", {
                                    key: 3,
                                    class: "dropdown-item",
                                    href: "javascript:void(0)",
                                    onClick: ($event: any) => (_ctx.showLogModal(childPhase))
                                  }, [
                                    _hoisted_30,
                                    _createTextVNode(_toDisplayString(_ctx.$t('log')), 1)
                                  ], 8, ["onClick"]))
                                : _createCommentVNode("", true),
                              (
                      childPhase.localStartedDate &&
                      childPhase.localEndDate &&
                      childPhase.log_type === 4
                    )
                                ? (_openBlock(), _createBlock("a", {
                                    key: 4,
                                    class: "dropdown-item",
                                    href: "javascript:void(0)",
                                    onClick: ($event: any) => (_ctx.update(childPhase))
                                  }, [
                                    _hoisted_31,
                                    _createTextVNode(_toDisplayString(_ctx.state.ui.isPostLoading.createPhase
                        ? _ctx.$t('loading1')
                        : _ctx.$t('task_completed')), 1)
                                  ], 8, ["onClick"]))
                                : _createCommentVNode("", true),
                              (
                      (_ctx.isActive(childPhase.permissions, 'edit_task')) &&
                      childPhase.localStartedDate &&
                      childPhase.localEndDate && childPhase.allMembers.length > 0 && childPhase.status_detail.status.code !== 'done' && !(_ctx.projectStatus ==2)
                    )
                                ? (_openBlock(), _createBlock("a", {
                                    key: 5,
                                    class: "dropdown-item",
                                    href: "javascript:void(0)",
                                    onClick: ($event: any) => (_ctx.redirectToTaskEdit(childPhase.uuid))
                                  }, [
                                    _hoisted_32,
                                    _createTextVNode(" " + _toDisplayString(_ctx.$t('edit')), 1)
                                  ], 8, ["onClick"]))
                                : _createCommentVNode("", true)
                            ])
                          ])
                        ])
                      ]))
                    : _createCommentVNode("", true)
                ]))
              }), 128))
            ]))
          : _createCommentVNode("", true)
      ])
    ]),
    (_ctx.state.data.showAddPhaseModal)
      ? (_openBlock(), _createBlock(_component_ToDoListAddPhaseModal, {
          key: 0,
          editMode: _ctx.state.data.editMode,
          editFrom: _ctx.state.data.editFrom,
          editData: _ctx.state.data.selectedToEdit,
          showAddPhase: _ctx.state.data.showAddPhaseModal,
          projectDetail: _ctx.project,
          updateTask: _ctx.state.data.updateTask,
          projectAcknowledgementDetail: _ctx.phase,
          onClose: _ctx.showAddPhaseModal,
          onAddPhase: _ctx.addNewPhase,
          onEditSelected: _ctx.updateSelected
        }, null, 8, ["editMode", "editFrom", "editData", "showAddPhase", "projectDetail", "updateTask", "projectAcknowledgementDetail", "onClose", "onAddPhase", "onEditSelected"]))
      : _createCommentVNode("", true),
    (_ctx.state.data.SuccessfulModalCustom)
      ? (_openBlock(), _createBlock(_component_SuccessfulModalCustom, {
          key: 1,
          onClose: _ctx.closeSuccessCustomModal,
          showModal: _ctx.state.data.SuccessfulModalCustom,
          titleMessage: _ctx.state.data.successFulMessage
        }, null, 8, ["onClose", "showModal", "titleMessage"]))
      : _createCommentVNode("", true),
    (_ctx.state.data.showSuccesRedirectModal)
      ? (_openBlock(), _createBlock(_component_SuccessfulModalCustom, {
          key: 2,
          onClose: _ctx.closeSuccessCustomModal,
          showModal: _ctx.state.data.showSuccesRedirectModal,
          titleMessage: _ctx.state.data.successFulMessage,
          isButton: true
        }, {
          default: _withCtx(() => [
            (_ctx.state.data.stripeUrl)
              ? (_openBlock(), _createBlock("div", _hoisted_33, [
                  _createVNode("p", null, _toDisplayString(_ctx.$t('you_dont_have_stripe_account')), 1),
                  (!_ctx.state.ui.isPostLoading.stripeAccount)
                    ? (_openBlock(), _createBlock("button", {
                        key: 0,
                        class: "btn-link mt-2",
                        onClick: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.redirectToStripeAccount && _ctx.redirectToStripeAccount(...args)))
                      }, _toDisplayString(_ctx.$t('click_to_setup_account')), 1))
                    : (_openBlock(), _createBlock("p", _hoisted_34, _toDisplayString(_ctx.$t('loading1')), 1))
                ]))
              : _createCommentVNode("", true)
          ]),
          _: 1
        }, 8, ["onClose", "showModal", "titleMessage"]))
      : _createCommentVNode("", true),
    _createVNode("div", _hoisted_35, [
      _createVNode("div", _hoisted_36, [
        _createVNode("div", _hoisted_37, [
          _createVNode("div", _hoisted_38, [
            _createVNode("div", _hoisted_39, [
              _createVNode("div", _hoisted_40, [
                _createVNode("h5", _hoisted_41, _toDisplayString(_ctx.$t('task_complete')), 1),
                _createVNode("p", _hoisted_42, _toDisplayString(_ctx.$t('add_details_on_the_task_completion')) + ". ", 1)
              ]),
              _createVNode("button", {
                type: "button",
                class: "close",
                onClick: _cache[3] || (_cache[3] = 
//@ts-ignore
(...args) => (_ctx.hideTaskCompleteModal && _ctx.hideTaskCompleteModal(...args))),
                "aria-label": "Close"
              }, [
                _createVNode(_component_router_link, { to: "/dashboard" }),
                _hoisted_43
              ])
            ]),
            _createVNode("div", _hoisted_44, [
              _createVNode(_component_ErrorList, {
                errors: _ctx.state.ui.error.errorList.createPhase,
                hasError: _ctx.state.ui.error.hasError
              }, null, 8, ["errors", "hasError"]),
              _createVNode("div", _hoisted_45, [
                _createVNode("div", _hoisted_46, [
                  _createVNode("label", _hoisted_47, _toDisplayString(_ctx.$t('details')), 1),
                  _withDirectives(_createVNode("input", {
                    type: "email",
                    class: "form-control",
                    id: "exampleInputEmail1",
                    "aria-describedby": "emailHelp",
                    placeholder: "Please add details if required.",
                    "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => (_ctx.state.data.selectedTaskComplete.details = $event))
                  }, null, 512), [
                    [_vModelText, _ctx.state.data.selectedTaskComplete.details]
                  ])
                ]),
                _createVNode("div", _hoisted_48, [
                  _createVNode("label", _hoisted_49, _toDisplayString(_ctx.$t('attachments')) + ": ", 1),
                  _createVNode("div", null, [
                    _createVNode(_component_DragAndDropZone, {
                      onDrop: _withModifiers(_ctx.dropFiles, ["prevent"]),
                      onDropFiles: _ctx.dropFiles
                    }, null, 8, ["onDrop", "onDropFiles"])
                  ]),
                  (_ctx.state.data.selectedTaskComplete.attachments)
                    ? (_openBlock(), _createBlock(_component_AppImageList, {
                        key: 0,
                        imagesToUpload: _ctx.state.data.selectedTaskComplete.attachments,
                        onSelectedToDelete: _ctx.deleteAttachementTaskCompleted
                      }, null, 8, ["imagesToUpload", "onSelectedToDelete"]))
                    : _createCommentVNode("", true)
                ])
              ])
            ]),
            _createVNode("div", _hoisted_50, [
              _createVNode("button", {
                type: "button",
                class: "btn default-btn",
                onClick: _cache[5] || (_cache[5] = 
//@ts-ignore
(...args) => (_ctx.taskCompleted && _ctx.taskCompleted(...args))),
                disabled: _ctx.state.ui.isPostLoading.createPhase
              }, _toDisplayString(_ctx.state.ui.isPostLoading.createPhase ? _ctx.$t('loading1') : _ctx.$t('task_completed')), 9, ["disabled"])
            ])
          ])
        ])
      ])
    ]),
    (_ctx.state.data.showToDoTaskLogModal)
      ? (_openBlock(), _createBlock(_component_ToDoTaskLogModal, {
          key: 3,
          showAddPhase: _ctx.state.data.showToDoTaskLogModal,
          selectedTask: _ctx.state.data.selected,
          onClose: _ctx.closeModal,
          onLogData: _ctx.logData
        }, null, 8, ["showAddPhase", "selectedTask", "onClose", "onLogData"]))
      : _createCommentVNode("", true)
  ], 64))
}